/*******************************************************************************
 * Copyright (c) 2018. keni <$email>
 *
 * This file calc.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * calc.js can not be copied and/or distributed
 * without the express permission of keni
 ******************************************************************************/
import {_} from 'underscore';

export function percentageSplit(items, item, count_key) {
	let value = 1, counterKey = count_key;
	// get all values and add them together
	// console.log('items', items);

	let total = items.reduce(function (memo, record) {
		let memory = memo;
		// let memory = (typeof memo[counterKey] !== 'undefined' && memo[counterKey] !== null) ? memo[counterKey] : 0;

		// let calc = record[counterKey] + memory;
		// console.log(
		// 	record.slug,
		// 	'memory', memory,
		// 	'calc',calc,
		// 	'record[counterKey]', record[counterKey],
		// 	memo[counterKey]);
		return record[counterKey] + memory;
	}, 0);

	let currentValue = item[counterKey];

	//what is the percentage equivalent
	let percentage = Math.round((currentValue / total) * 100);

// console.log('currentValue',currentValue,currentValue / 100,total);
// 	console.log('percentage', percentage, currentValue);
// 	console.log('total', total);
	// console.log('value', value);

	return percentage;
}
export function percentage(currentValue,total){
	let percentage = Math.round((currentValue / total) * 100);
	return percentage;
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/calc.js